// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

// Import loading screen CSS first to ensure it's in the main CSS bundle (with content hash)
// and loads before the body renders. This must be before any dynamic imports.
import './components/initial_loading_screen/initial_loading_screen.css';
import './guduu/loading.scss';
import {showStartupFailure, waitForStartup} from './guduu/startup_failure';
import {warmAuthMetadata} from './guduu/auth_metadata_request';

// Allow overriding the path used by webpack to dynamically resolve assets. This is driven by
// an environment variable in development, or by a window variable defined in root.html in
// production. The window variable is updated by the server after configuring SiteURL and
// restarting or by running the `mattermost config subpath` command.
window.publicPath = process.env.PUBLIC_PATH || window.publicPath || '/static/'; // eslint-disable-line no-process-env

// @ts-expect-error Field used by Webpack internally
__webpack_public_path__ = window.publicPath;

// Define the subpath at which Mattermost is running. Extract this from the publicPath above to
// avoid depending on Redux state before it is even loaded. This actual global export is used
// in a minimum of places, as it is preferred to leverage react-router, configured to use this
// basename accordingly.
window.basename = window.publicPath.substr(0, window.publicPath.length - '/static/'.length);

// Modified by GUDUUOS INC: isolate live Matrix bootstrap from fixture mode.
if (process.env.GUDUU_MATRIX === 'true') { // eslint-disable-line no-process-env
    // Overlap public discovery with bootstrap downloads; session validates it before use.
    if (['/', '/login', '/signup'].includes(window.location.pathname)) {
        warmAuthMetadata(process.env.GUDUU_HOMESERVER || ''); // eslint-disable-line no-process-env
    }
    // Only bound the module download, not authentication or workspace writes.
    waitForStartup(import('./guduu/bootstrap')).then(async ({boot}) => {
        if (await boot()) await import('./entry');
    }).catch(showStartupFailure);
} else {
    import('./entry').catch(showStartupFailure);
}

// This empty export forces this to be treated as a module by the TS compiler
export {};
